import { NineSliceContainer } from "@ravalmatic/catafractum-utils";
import { GameVars } from "../../../GameVars";
import { BoardManager, BoardPlaySnapshot } from "../BoardManager";

export class BotErrorPanel extends Phaser.GameObjects.Container {

    private static readonly WIDTH = 560;
    private static readonly HEIGHT = 240;

    private readonly title: Phaser.GameObjects.Text;
    private readonly message: Phaser.GameObjects.Text;
    private readonly retryButton: Phaser.GameObjects.Rectangle;
    private readonly unsubscribeFromPlay: () => void;

    constructor(scene: Phaser.Scene, boardManager: BoardManager) {

        super(scene);
        const background = new NineSliceContainer(
            scene, 0, 0, "texture_atlas_1", "contract_bid_bg",
            BotErrorPanel.WIDTH, BotErrorPanel.HEIGHT, 48
        );
        this.title = new Phaser.GameObjects.Text(scene, 0, -86, "", {
            fontFamily: "Baloo2-Bold", fontSize: "28px", color: "#D92727"
        }).setOrigin(.5);
        this.message = new Phaser.GameObjects.Text(scene, 0, -30, "", {
            fontFamily: "Baloo2-SemiBold", fontSize: "22px", color: "#1F252D",
            align: "center", wordWrap: { width: BotErrorPanel.WIDTH - 56 }, maxLines: 3
        }).setOrigin(.5);
        this.retryButton = new Phaser.GameObjects.Rectangle(scene, 0, 75, 240, 44, 0x08618c)
            .setStrokeStyle(2, 0x001b39);
        this.retryButton.on(Phaser.Input.Events.POINTER_UP, () => {
            if (this.visible && this.retryButton.input?.enabled) {
                boardManager.retryBotPlay();
            }
        });
        const retryLabel = new Phaser.GameObjects.Text(scene, 0, 75, "Reintentar", {
            fontFamily: "Baloo2-Bold", fontSize: "26px", color: "#ffffff"
        }).setOrigin(.5);
        this.add([background, this.title, this.message, this.retryButton, retryLabel]);
        this.relayout();
        this.unsubscribeFromPlay = boardManager.subscribeToPlay(this.onPlayStateChanged.bind(this));
    }

    public relayout(): void {

        this.setPosition(GameVars.gameWidth / 2, GameVars.gameHeight / 2);
        const scale = Math.min(
            1, (GameVars.gameWidth - 32) / BotErrorPanel.WIDTH,
            (GameVars.gameHeight - 32) / (BotErrorPanel.HEIGHT * GameVars.scaleY)
        );
        this.setScale(scale, scale * GameVars.scaleY);
    }

    public destroy(fromScene?: boolean): void {

        this.unsubscribeFromPlay();
        super.destroy(fromScene);
    }

    private onPlayStateChanged(snapshot: BoardPlaySnapshot): void {

        const error = snapshot.botError;
        this.setVisible(error !== null);
        if (error === null) {
            this.retryButton.disableInteractive();
            return;
        }
        this.title.setText(`Error del jugador ${["N", "E", "S", "W"][error.seat]}`);
        this.message.setText(error.message);
        this.retryButton.setInteractive({ useHandCursor: true });
    }
}
